import {
  ActivityChangeOptions,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';

import { createWorkflowUpdatesChangeExtension } from './workflow-updates-change';

type HypothesisData = { text?: string } | null;

const HypothesisChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as HypothesisData;
  const newValue = change.newValue as HypothesisData;

  return (
    <ActivityTagItem
      oldValue={oldValue?.text ?? ''}
      newValue={newValue?.text ?? ''}
      ariaLabel="Hypothesis text"
    />
  );
};

export const HYPOTHESIS_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension(
  {
    id: 'hypothesis-change',
    predicate: ({ change }) => change.fieldPath === '/module_data/hypothesis',
    render: HypothesisChangeRender,
  },
);
